import { render, staticRenderFns } from "./ProductConsumptionDetail.vue?vue&type=template&id=0ae68f41&"
import script from "./ProductConsumptionDetail.vue?vue&type=script&lang=js&"
export * from "./ProductConsumptionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports